import { TabsNavigation } from '@/theme/components/TabsNavigation/TabsNavigation';
import { styled } from '@/theme/index';

export const AppHeader = styled('header')(({ theme }) => ({
  marginBottom: theme.spacing(0),
  boxShadow: '0px 1px 2px rgba(117, 117, 117, 0.5)',
  padding: `${theme.spacing(0)} ${theme.spacing(1.25)}`,
  backgroundColor: '#fff',
  position: 'relative',

  '& > .MuiStack-root': {
    maxWidth: '1600px',
    height: 'inherit',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export const StyledHeaderTabsNavigation = styled(TabsNavigation)(
  ({ theme }) => ({
    '.MuiTab-root': {
      textDecoration: 'unset',
      fontSize: theme.spacing(1.75),
    },
    '&.mobile': {
      marginTop: theme.spacing(-1.5),
      marginBottom: theme.spacing(2),
      paddingBottom: '1px',
      borderBottom: `1px solid ${theme.palette.secondary.light}`,
      '.MuiTabs-flexContainer': {
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      },
      '.MuiTab-root': {
        flex: '1 1 33%',
        fontWeight: 700,
        lineHeight: theme.spacing(3),
        borderBottom: 'unset',
        paddingBottom: theme.spacing(1.5),
        color: `${theme.palette.text.primary}`,
      },
      '.MuiTabs-indicator': {
        display: 'none',
      },
      '.Mui-selected': {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        color: `${theme.palette.primary.main}`,
        opacity: 'unset',
      },
    },
    '&.desktop': {
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(2),
      '&--no-margin-left': {
        marginLeft: 0,
      },
      '.MuiTabs-indicator': {
        display: 'none',
      },
      '.MuiTab-root': {
        borderRadius: theme.spacing(0.5),
        border: `1px solid ${theme.palette.success.main}`,
        color: theme.palette.success.main,
        display: 'flex',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 500,
        marginRight: theme.spacing(1),
        minHeight: theme.spacing(5),
        '&:hover': {
          textShadow: '0 0 0.8px',
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.success.main,
          color: theme.palette.success.contrastText,
          fontWeight: 700,
          borderBottom: 'none',
        },
      },
    },
  })
);

export const HeaderNavItem = styled('li')(({ theme }) => ({
  float: 'left',
  position: 'relative',
  display: 'none',
  paddingTop: theme.spacing(0.375),
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },
  '&.menu': {
    display: 'block',
  },
  '&.notification-bell': {
    display: 'block',
  },
  '&.custom-menu': {
    display: 'flex',
    alignItems: 'center',
  },
  ':hover,&.active': {
    cursor: 'pointer',
    '.selected-tab': {
      display: 'block',
    },
  },
  '.selected-tab': {
    display: 'none',
  },
  '.smart-search-input': {
    display: 'block',
  },
}));
